import { render, staticRenderFns } from "./PwdRetrieve.vue?vue&type=template&id=f8c2ba3c&scoped=true"
import script from "./PwdRetrieve.vue?vue&type=script&lang=js"
export * from "./PwdRetrieve.vue?vue&type=script&lang=js"
import style0 from "./PwdRetrieve.vue?vue&type=style&index=0&id=f8c2ba3c&prod&lang=scss&scoped=true"
import style1 from "./PwdRetrieve.vue?vue&type=style&index=1&id=f8c2ba3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c2ba3c",
  null
  
)

export default component.exports